import { render, staticRenderFns } from "./terms-march.vue?vue&type=template&id=a0ba673e&scoped=true&"
import script from "./terms-march.vue?vue&type=script&lang=js&"
export * from "./terms-march.vue?vue&type=script&lang=js&"
import style0 from "./terms-march.vue?vue&type=style&index=0&id=a0ba673e&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ba673e",
  null
  
)

export default component.exports